var map = {
	"./2013-Split-1-game4.png": 2086,
	"./2014-Split-1-game5.png": 6064,
	"./2014-Split-2-game4.png": 2506,
	"./2015-Split-1-game3.png": 1199,
	"./2015-Split-2-game3.png": 2311,
	"./2016-Split-1-game3.png": 6676,
	"./2016-Split-2-game4.png": 2656,
	"./2017-Split-1-game3.png": 6077,
	"./2017-Split-2-game4.png": 5985,
	"./2018-Split-1-game5.png": 268,
	"./2018-Split-2-game5.png": 8527,
	"./2019-Split-1-game5.png": 9653,
	"./2019-Split-2-game5.png": 3982,
	"./2020-Split-1-game3.png": 7695,
	"./2020-Split-2-game4.png": 8411,
	"./2021-Split-1-game4.png": 2425,
	"./2021-Split-2-game4.png": 1018,
	"./2022-Split-1-game5.png": 3099,
	"./2022-Split-2-game3.png": 7806,
	"./2023-Split-1-game3.png": 2340,
	"./2023-Split-2-game4.png": 9808,
	"./2024-Split-1-game5.png": 6685,
	"./2024-Split-2-game4.png": 9343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8255;